import React from "react";
import WorkForceDashboard from "../../views/WorkForceDashboard";

const WorkForceDashboardPage = () => <WorkForceDashboard />;

export default WorkForceDashboardPage;
